import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbAlertModule,
  NgbModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ServicesModule } from '../../shared/services/services.module';
import { HttpClientModule } from '@angular/common/http';
import { SharedComponentsModule } from '../../components-gallery/shared/shared.module';
import {
  RECAPTCHA_LANGUAGE,
  RecaptchaFormsModule,
  RecaptchaModule,
} from 'ng-recaptcha';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import {FindVehicleClaimComponent} from "./find-vehicle-claim.component";
import {FindVehicleClaimRoutingModule} from "./find-vehicle-claim-routing.module";

@NgModule({
  providers: [
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'cs',
    },
  ],
  imports: [
    RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaFormsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FindVehicleClaimRoutingModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    NgbAlertModule,
    NgbModule,
    ServicesModule,
    MatSnackBarModule,
    NgbTooltipModule,
    HttpClientModule,
    SharedComponentsModule,
    MatTooltipModule,
    MatSelectModule,
  ],
  declarations: [FindVehicleClaimComponent],
  entryComponents: [],
})
export class FindVehicleClaimModule {}
